import React from 'react'
import Flex from 'typescript-styled-flex'
import InputRadio from './InputRadio'
import { IRadioProps } from '.'

function Radio(C: React.ComponentType<{}>) {
  return function({
                    name,
                    value,
                    onChange,
                    onClick,
                    temporaryValue,
                    className,
                    inputRef,
                    disabled,
                  }: IRadioProps) {
    function onchange(e: React.SyntheticEvent<HTMLInputElement>) {
      e.stopPropagation()
      if (onChange) {
        onChange(e)
      }
    }

    return (
      <Flex style={{ position: 'relative' }} onClick={onClick}>
        <InputRadio
          ref={inputRef}
          className={className}
          name={name}
          value={temporaryValue}
          onChange={onchange}
          type="radio"
          disabled={disabled}
          checked={temporaryValue === value}
        />
        <C />
      </Flex>
    )
  }
}

export default Radio
